import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const baseUrl = "http://hdeng2024.cafe24.com/api/controller/admin/inquiry";

export const adminInquiryApiSlice = createApi({
  reducerPath: "adminInquiryApiSlice",
  baseQuery: fetchBaseQuery({ baseUrl: baseUrl }),
  endpoints: (builder) => ({
    // 문의하기 리스트 가져오기 
    getInquiryList : builder.mutation({
      query : (param : {page : any, size : number, keyword : string, sortColumn : string, sortOrder : string}) => {
        return{
          url : `/getInquiryList.php?page=${param.page}&size=${param.size}&keyword=${param.keyword}&sortColumn=${param.sortColumn}&sortOrder=${param.sortOrder}`
        }
      }
    }),
    // 문의하기 상세보기
    getInquiryDetail : builder.mutation({
      query : (param : {idx: any}) => {
        return{
          url : `/getInquiryDetails.php?inquiry_idx=${param.idx}`
        }
      }
    }),
    // 문의 답변 상태 변경
    updInquiry : builder.mutation({
      query : (body : any) => {
        return{
          url : '/updInquirys.php', method : 'post', body
        }
      }
    })
  }),
});

export const {
    useGetInquiryListMutation, useGetInquiryDetailMutation, useUpdInquiryMutation
} = adminInquiryApiSlice;